export var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/@types/utils.js
// module id = 2376
// module chunks = 33